import { useMemo } from 'react';
import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

import { useBreadcrumbHostingsQuery } from '../../Hostings';
import { DynamicBreadcrumbWrapper } from './DynamicBreadcrumbWrapper';

const DynamicHostingsByIdBreadcrumb: BreadcrumbComponentType<'hostingId'> = ({ match }) => {
  const hostingId = useMemo(() => match.params.hostingId ?? '', [match.params.hostingId]);

  const breadcrumbQuery = useBreadcrumbHostingsQuery(hostingId)();

  return <DynamicBreadcrumbWrapper { ...breadcrumbQuery }/>;
};

const DynamicHostingsListBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Хостинги</span>;
};

export const DynamicHostingsBreadcrumb = {
  DynamicHostingsListBreadcrumb,
  DynamicHostingsByIdBreadcrumb
};
